import { Injectable } from '@angular/core';
import { TaskTagService } from '../../common/services/task-tag.service';

@Injectable({
  providedIn: 'root',
})
export class EclTaskTagService extends TaskTagService {
  // tslint:disable:variable-name
  protected ParseTask = Parse.Object.extend('ECLTask');
  protected ParseTag = Parse.Object.extend('ECLTag');
  protected ParseTaskTag = Parse.Object.extend('ECLTaskTag');
  // tslint:enabled
}
